<template>
  <div class="backyanse">
    <MyHelloWorld :numer="number"></MyHelloWorld>
    <!-- 右边图标 -->
    <Righticon></Righticon>

    <el-row>
      <el-col :span="24">
        <el-container class="conta auto">
          <el-image class="img" :src="$t('menu.srcQiYe')" alt=""></el-image>
        </el-container>
      </el-col>
    </el-row>

    <div class="content">
      <el-row>
        <el-col :span="7">
          <Content>
            <template #MingChen>
              <div>{{ $t("menu.AboutUs") }}</div>
            </template>

            <template #ContentEr>
              <div class="inlineer">
                <li><div style="color: #1d2088">{{ $t("menu.qiye") }}</div></li>
              </div>
            </template>
          </Content>
        </el-col>
       <div v-for="(item, index) in SelectList" :key="index">
          

        <el-col :span="17" v-if="item.category === 'Brief'">
          <div class="inline">
            <el-divider direction="vertical"></el-divider>
            <h3 class="Xjiao">{{ item.title }}</h3>
          </div>

          <div class="fff">
            <el-row>
              <el-col :span="24">
                <span style="color: #999999" v-html="item.explain"></span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <!-- <el-image
                  style="width: 777px; height: 395px; padding: 20px 10px"
                  :src="item.cover"
                ></el-image> -->
              </el-col>
            </el-row>
          </div>
        </el-col>
       </div>
      </el-row>
    </div>

    <MyFooter> </MyFooter>
  </div>
</template>

<style scoped>
.White {
  position: relative;
  top: 69px;
  height: 60px;
  width: 280px;
  background: #999999;
}
.conta {
  margin-top: 161px;
}

.Xjiao {
  color: #1d2088;
  font-size: 20px;
}

.divider {
  background-color: #eeeeee;
}
.fff {
  background: #ffffff;
  padding: 0px 20px;
  margin-bottom: 20px;
}
</style>


<script>
export default {
  name: "EnterpriseProfile",

  data() {
    return {
      number: "1",
   
      // srcQiYeer: require("@/assets/images/about/qiyejianjie.jpg"),
      SelectList: [],
      title: "",
    };
  },

    created: function () {
      //  console.log(this.$i18n.locale)
      if (this.$i18n.locale == "TC") {
        this.title = "TC";
      } else if (this.$i18n.locale == "EN") {
        this.title = "EN";
      } else if (this.$i18n.locale == "SC") {
        this.title = "SC";
      }
      //  console.log(this.title)
      this.getSelect();
    },
    methods: {
      async getSelect() {
        console.log(this.title);
        const { data: res } = await this.$http.get(
          "/AboutUs/GetCompanyProfile",
          {
            params: { languageType: this.title },
          }
        );

        if (res.code !== 200) return console.log("数据请求失败! ");
        this.SelectList = res.data;
        console.log(this.SelectList);
      },
    },
  
};
</script>